module.exports = __webpack_public_path__ + "media/images/logo-color-311b972f06243ebf067984656dd5ecf5.png";